const refreshBundleComponents = async () => {
  try {
    const response = await fetch('/?section_id=smart-cart');

    if (!response.ok) {
      return new Error(`Fetch error: ${response.status}`);
    }

    const htmlText = await response.text();
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');
    const tplScript = doc.getElementById('rebuy-cart-template');

    if (!tplScript) {
      console.warn('Nie znaleziono #rebuy-cart-template');
      return;
    }

    const tplHtml = tplScript.textContent.trim();
    const container = document.createElement('div');
    container.innerHTML = tplHtml;

    const sections = container.querySelectorAll('[data-variant].bundle');
    const containers = document.querySelectorAll('.components-wrapper');

    containers.forEach((container) => (container.innerHTML = null));
    sections.forEach((node) => {
      const variant = node.getAttribute('data-variant');
      const target = document.querySelector(`[data-variant="${variant}"].components-wrapper`);
      if (target) target.innerHTML = node.outerHTML;
    });
  } catch (err) {
    console.error('refresh error:', err);
  }
};

//  TODO replace event (create custom event for bundles change)
document.addEventListener('rebuy:cart.enriched', refreshBundleComponents);
